import { CheckCircle, WarningOctagon } from "@phosphor-icons/react";

export const SeverityIcon = ({ severity, size = 14 }) => {
  if (severity === "critical") return <WarningOctagon size={size} className="text-red-500" weight="fill" />;
  if (severity === "warn") return <WarningOctagon size={size} className="text-yellow-500" weight="fill" />;
  return <CheckCircle size={size} className="text-emerald-500" weight="fill" />;
};
